module.exports = __webpack_public_path__ + "static/media/image_active.00d2eabb.svg";